import { Component, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-challenges-new',
  templateUrl: './challenges-new.component.html',
  styleUrls: ['./challenges-new.component.css']
})
export class ChallengesNewComponent implements OnInit {

  participantsItems = [];
  participantsItemsFinal = [];
  tab: any = 1;
  minDate = new Date();
  createdChallenge: any;
  invalid: Boolean = false;
  activities: Array<any> = [];
  categories: Array<any> = [];
  outcomes: Array<any> = [];
  goals: Array<any> = [];
  users: Array<any> = [];
  todisplayusers: Array<any> = [];

  challengeForm = new FormGroup({
    title: new FormControl('', [Validators.required]),
    category: new FormControl('', [Validators.required]),
    activity: new FormControl('', [Validators.required]),
    goal: new FormControl('', [Validators.required]),
    outcome: new FormControl('', [Validators.required]),
    startdate: new FormControl(new Date(), [Validators.required]),
    enddate: new FormControl('', [Validators.required]),
    createdBy: new FormControl(this.apiservice.user._id),
    description: new FormControl('', [Validators.required])
  });

  get title() { return this.challengeForm.get('title'); }
  get category() { return this.challengeForm.get('category'); }
  get activity() { return this.challengeForm.get('activity'); }
  get goal() { return this.challengeForm.get('goal'); }
  get outcome() { return this.challengeForm.get('outcome'); }
  get startdate() { return this.challengeForm.get('startdate'); }
  get enddate() { return this.challengeForm.get('enddate'); }
  get description() { return this.challengeForm.get('description'); }

  constructor(
    public translations: TranslationService,
    private apiservice: ApiService
  ) { }

  ngOnInit() {
    this.getData();
    this.apiservice.getActivities().subscribe((res: any) => {
      this.activities = res.data;
    })

    this.apiservice.getAllUsers().subscribe((res: any) => {
      this.users = res.data;
      this.todisplayusers = this.users.map((ele, index) => { return { value: ele._id, display: ele.firstname + ' ' + ele.lastname } })
    });
  }

  getData() {
    if (this.apiservice.user.profiles) {
      this.apiservice.getProfileById(this.apiservice.user.profiles._id, this.apiservice.user._id, true).subscribe((res: any) => {
        this.categories = res.data.categoryMap.map(cat => {
          cat['category']['goals'] = cat['goals'];
          return cat;
        });
        this.categories.sort(function(a, b) {
          return a.rank - b.rank;
        });
      })
    } else {
      this.apiservice.getCreatedCategories(this.apiservice.user._id, 'all').subscribe((res: any) => {
        this.categories = res.data.map(cat => {
          cat['category'] = cat;
          return cat;
        });
      });
    }
  }


  setGoals(event) {
    this.challengeForm.patchValue({ goal: '', outcome: '' });
    let index = this.categories.findIndex(data => data.category._id == event.target.value);
    this.goals = this.categories[index]['category']['goals'];
  }

  setOutcomes(event) {
    this.challengeForm.patchValue({ outcome: '' });
    let index = this.goals.findIndex(data => data._id == event.target.value);
    this.outcomes = this.goals[index]['outcomes'];
  }


  onTagAdd(tag) {
    if (this.participantsItemsFinal == undefined) {
      this.participantsItemsFinal = [];
    }
    let user = this.users.find(data => data._id == tag.value);
    (this.participantsItemsFinal).push({ value: user, display: user.firstname + ' ' + user.lastname });
    this.participantsItems = [];
  }

  onTagRemove(tag) {
    this.participantsItemsFinal.splice((this.participantsItemsFinal).indexOf(tag), 1);
  }

  next() {
    this.invalid = false;
    if (this.tab == 1) {
      if (this.challengeForm.valid) {
        this.apiservice.createChallenge(this.challengeForm.value).subscribe((res: any) => {
          this.createdChallenge = res.data;
          this.tab += 1;
        });
      } else {
        return this.invalid = true;
      }
    } else if (this.tab == 2) {
      let formdata = [];
      this.participantsItemsFinal.forEach(element => {
        formdata.push({ challenge: this.createdChallenge._id, participant: element.value['_id'] });
      });
      formdata.push({ challenge: this.createdChallenge._id, participant: this.apiservice.user._id });
      this.apiservice.invitePartcipants({ name: this.createdChallenge.title, formData: formdata }).subscribe(res => {
        this.tab += 1;
      });
    }
  }

}
